import React, { useState } from 'react';
import { FaSearch, FaBell, FaUserCircle, FaCog, FaSignOutAlt } from 'react-icons/fa';
import './Topbar.css';

const Topbar = ({ onMenuClick }) => {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const userData = JSON.parse(localStorage.getItem('userData') || '{}');

  const notifications = [
    { id: 1, message: 'New expense added', time: '5 minutes ago' },
    { id: 2, message: 'Monthly report is ready', time: '1 hour ago' },
    { id: 3, message: 'Budget limit reached', time: '2 hours ago' },
  ];

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userData');
    window.location.href = '/login';
  };

  return (
    <div className="topbar">
      <div className="topbar-left">
        <button className="menu-btn" onClick={onMenuClick}>
          <span></span>
          <span></span>
          <span></span>
        </button>
        
      </div>

      <div className="topbar-right">
        <div className="notification-wrapper">
          <button 
            className="notification-btn"
            onClick={() => setShowNotifications(!showNotifications)}
          >
            <FaBell />
            {notifications.length > 0 && (
              <span className="notification-badge">{notifications.length}</span>
            )}
          </button>

          {showNotifications && (
            <div className="notification-dropdown">
              <div className="notification-header">
                <h3>Notifications</h3>
                <button className="mark-all-read">Mark all as read</button>
              </div>
              <div className="notification-list">
                {notifications.map(notification => (
                  <div key={notification.id} className="notification-item">
                    <p className="notification-message">{notification.message}</p>
                    <span className="notification-time">{notification.time}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="user-menu-wrapper">
          <button 
            className="user-menu-btn"
            onClick={() => setShowUserMenu(!showUserMenu)}
          >
            {userData.profile_picture ? (
              <img 
                src="/carson5.jpg" 
                alt="Profile" 
                className="user-avatar"
              />
            ) : (
              <FaUserCircle className="user-avatar-icon" />
            )}
            <span className="user-name">{userData.name || ''}</span>
          </button>

          {showUserMenu && (
            <div className="user-dropdown">
              <div className="user-info">
                <h3>{userData.name || ''}</h3>
                <p>{userData.email || 'user@example.com'}</p>
              </div>
              <div style={{backgroundColor: '#fff'}} className="dropdown-menu">
                <button className="menu-item">
                  <FaUserCircle />
                  <span>Profile</span>
                </button>
                <button className="menu-item">
                  <FaCog />
                  <span>Settings</span>
                </button>
                <button className="menu-item" onClick={handleLogout}>
                  <FaSignOutAlt />
                  <span>Logout</span>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Topbar;
